import { Outlet, useLocation } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { TooltipProvider } from '@/components/ui/tooltip';

import { AppSidebar } from './Privatize/navbar/AppSidebar';
import { CommandPalette } from '@/components/CommandPalette';
import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary';
import { UserContext } from 'contexts';
import { useAuth } from 'contexts/AuthContext';

export function PrivateLayout() {
    const { user } = useAuth();
    const { pathname } = useLocation();

    // AuthGuard guarantees user is non-null here
    if (!user) return null;

    return (
        <UserContext.Provider value={user}>
            <TooltipProvider>
                <SidebarProvider>
                    <AppSidebar />
                    <CommandPalette />
                    <SidebarInset key={pathname} className="h-svh overflow-y-auto">
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </SidebarInset>
                </SidebarProvider>
            </TooltipProvider>
        </UserContext.Provider>
    );
}
